<template>
  <div>

    <v-layout row justify-end class="mt-2">
      <v-flex xs12>
        <InputSearch class="mb-3" :search="filter" @clickSearch="onSearch" :placeholder="'ค้นหา'" />
      </v-flex>
    </v-layout>

    <v-flex xs12>
      <div style="display: flex; align-items: center">
        <v-flex>
          <Typography h2 bold :label="$t('Agency')" />
        </v-flex>
        <v-btn
          variant="outlined"
          icon
          :color="'#BECCDB'"
          style="border-radius: 50% !important"
          @click="showCreate"
        >
          <img :src="`/static/img/Add.png`" alt class="responsive-img" style="height: 14px" />
        </v-btn>
      </div>
    </v-flex>

    <!-- <div style="display: flex; justify-content: flex-end">
      <div class="depainput form-control mb-3" style="position: relative; width: 40%">
        <input
          v-model="filter.name"
          @keyup="getData"
          style="padding-right: 47px !important"
          type="text"
        />
        <v-btn
          @click="getData"
          :loading="loading"
          style="position: absolute; right: 0px; top: 0px"
          icon
          ><v-icon color="primary">search</v-icon></v-btn
        >
      </div>
    </div> -->
    <v-layout class="my-5" justify-center v-if="loading">
      <v-progress-circular
        :size="100"
        :width="10"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-layout>
    <v-data-table
      v-else
      :headers="headers"
      :items="items"
      hide-actions
      class="fixTable"
      :pagination.sync="pagination"
      :loading="loading"
    >
      <template v-slot:no-data>
        <div v-if="loading" class="text-xs-center">Loading, Please wait</div>
        <div v-else class="text-xs-center">No data available</div>
      </template>
      <template v-slot:headers="props">
        <tr style="background-color: #152d53; color: white">
          <th
            style="background-color: #152d53; color: yellow; text-align: left"
            v-for="(header, k) in props.headers"
            :key="header.text + k"
          >
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr class="py-3 depatable">
          <td class="text-xs-center cursor-5" @click="showDetail(props.item)">
            <Typography left style="width: 220px" h5 :label="props.item.name || '-'" />
          </td>
          <td class="text-xs-center" style="word-break: break-word">
            <!-- <Typography left h5 :label="props.item.provincelist || '-'" /> -->
            <TagsProvinces :item="props.item" />
          </td>
          <td class="text-xs-right">
            <!-- <v-btn @click="showEdit(props.item)" icon outline>
              <v-icon color="primary">edit</v-icon></v-btn
            >
            <v-btn @click="deleteData(props.item)" icon outline>
              <v-icon color="primary">delete</v-icon></v-btn
            > -->
            <TooltipTable
              :datas="props"
              @modalEdit="showEdit(props.item)"
              @Delete="deleteData(props.item)"
              showDelete
            ></TooltipTable>
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- <div class="my-3 flex-all-center">
      <v-pagination
        v-model="pagination.page"
        :length="Math.round(items.length / pagination.rowsPerPage)"
      ></v-pagination>
    </div> -->
    <v-dialog v-model="agencyEditDialog" width="500px" persistent :content-class="'overflow-y-visible'">
      <v-card v-if="agencyEditDialog">
        <agency-edit
          @close="agencyEditDialog = false"
          @onsave="onsave"
          :edittype="agencyEditType"
          :editdata="agencyEditData"
        ></agency-edit>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalAgency" width="500px" persistent>
      <v-card v-if="modalAgency" style="height: 400px;box-shadow: none;">
        <div class="text-xs-right">
          <v-btn icon @click="modalAgency = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="px-3 pb-3">
          <!-- <div class="primary--text" style="font-size: 21px; font-weight: bold">Odoo Info</div> -->

          <Typography left h2 bold :label="agencyDetail.name || '-'" />
          <div style="display: flex; flex-wrap: wrap;gap: 6px" class="mt-2 mb-3">
            <div v-for="(items, k) in agencyDetail.provincelist" :key="k">
              <div
                style="padding: 0px 8px; border-radius: 6px; display: flex"
                class="background-lightblue01"
              >
                {{ items }}
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <Paginations
      @clickPagination="changepage"
      @sortPage="sortPage"
      :pageCount="pageCount"
      :numberPage="numberPage"
      :page="page"
    />
  </div>
</template>

<script>
import api from '@/api'
import AgencyEdit from './AgencyEdit.vue'
import { mapGetters } from 'vuex'
import InputSearch from '@/components/elements/InputSearch.vue'
import Typography from '@/components/elements/Typography.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Paginations from '@/components/elements/Paginations.vue'
import TagsProvinces from '@/components/elements/TagsProvinces.vue'
import _ from 'lodash'

export default {
  components: {
    AgencyEdit,
    InputSearch,
    Typography,
    TooltipTable,
    Paginations,
    TagsProvinces
  },
  data() {
    return {
      agencyEditDialog: false,
      modalAgency: false,
      agencyDetail: {},
      agencyEditType: '',
      agencyEditData: '',
      filter: {
        nameAll: ''
      },
      items: [],
      pagination: {
        // descending: false,
        // sortBy: 'name',
        rowsPerPage: 999
      },
      loading: false,
      headers: [
        { text: 'ชื่อหน่วยร่วม', value: 'name', align: 'center' },
        { text: 'จังหวัด', value: 'provincelist', align: 'center', width: '3%' },
        { text: '', value: '', align: 'center', sortable: false, width: '1%' }
      ],
      page: 1,
      pageTotal: 0,
      rowsPerPage: 12,
      numberPage: {
        page: undefined
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageCount() {
      if (this.pageTotal !== 0) {
        let count = Math.ceil(this.pageTotal / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    }
  },
  mounted() {
    this.getData()
    // this.getData = _.debounce(this.getData, 1000)
  },
  methods: {
    async onSearch() {
      this.loading = true
      this.page = parseInt(1)
      await this.getData()
      this.loading = false
    },
    async sortPage(pages) {
      let count = Math.ceil(this.pageTotal / this.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        await this.getData()
        this.loading = false
      }
    },
    deleteData(item) {
      this.$swal
        .fire({
          type: 'question',
          text: 'ยืนยันการลบ?',
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            var data = {
              pageid: this.selectedBot.pageid,
              name: item.name
            }
            api.deleteDepaAgencyMaster(data, (err, response) => {
              if (response.responsecode == 200) {
                this.getData()
              }
            })
          }
        })
    },
    onsave() {
      this.getData()
      this.agencyEditDialog = false
    },
    showCreate() {
      this.agencyEditType = 'create'
      this.agencyEditDialog = true
    },
    showEdit(item) {
      this.agencyEditType = 'edit'
      this.agencyEditData = item
      this.agencyEditDialog = true
    },
    showDetail(item) {
      this.modalAgency = true
      this.agencyDetail = item
      this.agencyDetail.provincelist = item.provincelist.split(',')
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        name: this.filter.nameAll ? this.filter.nameAll : null,
        limit: this.limitCom,
        offset: this.offsetCom
      }
      this.loading = true
      api.getDepaAgencyMaster(data, (err, response) => {
        this.loading = false
        this.items = response.data.map(item => ({
          ...item,
          provincelist: item.provincelist.split(',')
        }))
        this.pageTotal = response.total ? response.total : []
      })
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.getData()
      this.loading = false
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
  tbody {
    tr {
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/techhuntMaster/Agency.vue